goog.provide('el8.appchart.dialog.addEditImmunizationNew');

goog.require('el8.app.shared.clickItemOpts');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appshared.dialog.editPatient');
goog.require('el8.appshared.dialog.viewEducationalHandouts');
goog.require('el8.appshared.form.buttons');
goog.require('el8.data.currUser');
goog.require('el8.ptdata.ptAllergies');
goog.require('el8.ptdata.ptImmunizationDeclines');
goog.require('el8.ptdata.ptImmunizations');
goog.require('el8.ptdata.ptIntolerances');
goog.require('el8.service.tooltip');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.addEditImmunizationNew');
goog.require('el8.template.mindreader');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.amplitude.immunizationHelpers');
goog.require('el8.util.consts');
goog.require('el8.util.datecompare');


el8.appchart.dialog.addEditImmunizationNew = (function() {

    var _currImmunizationId = null; // used when editing an existing immunization
    var _declineCode = null; // used when the Pt Declined button is visible
    var successCb = null;
    var registrySubmissionTypeIds = [1, 3];  // Could get these from BE
    var manualVaccineValidationEnabled = false; // Used while populating dialog on show

    var MINDREADER_WIDTH = 350;
    var STD_FIELD_LENGTH = 40;
    var LONG_FIELD_LENGTH = 100;

    var ADMINISTERED_ACTION = 'administered';
    var DECLINED_ACTION = 'patientDeclined';
    var PREV_ADMIN_ACTION = 'previouslyAdministered';

    var SEND_TO_REGISTRY_ACTION = 'yes';
    var DONT_SEND_TO_REGISTRY_ACTION = 'no';
    var HISTORICAL_SOURCES = ["01", "02", "03", "04", "05", "06", "07", "08"];
    var NEW_INFO_SOURCE = "00";
    var CVX_CODES_TO_EXCLUDE = ["95", "96", "97", "98"]; // excluded from registries

    var that = new el8.uiwidget.FormDialog({
        title: 'Document Vaccination',
        autoHeight: true,
        width: 600,
        position: 'center',
        contentFn: function() {
            return el8.template.appchart.dialog.addEditImmunizationNew.form();
        }
    });

    /*
     * Giant form definition. Note that fields must be defined in
     * static/js/legacy/el8/app/ptdata/ptImmunizations.js
     * to be accessible by the server on submission
     */
    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'selectImmunizationRecord',
                selector: ':input[name="selectImmunizationRecord"]',
                changeFn: function() {
                    selectImmunizationRecordUI();
                }
            },
            {
                name: 'allowedSharing',
                selector: ':input[name="allowedSharing"]',
                changeFn: function() {
                    selectSendToRegistryUI();
                }
            },
            {
                name: 'selectImmunizationRegistry',
                selector: ':input[name="selectImmunizationRegistry"]',
                maxLength: LONG_FIELD_LENGTH,
                validate: {
                  required: function() { return isSendingNewToRegistry(); },
                }
            },
            {
                name: 'priorityPopulation',
                selector: ':input[name="priorityPopulation"]',
                maxLength: LONG_FIELD_LENGTH,
                validate: {
                  required: function() { return isSendingNewToRegistry(); },
                }
            },
            {
                name: 'patientConsent',
                selector: ':input[name="patientConsent"]',
                validate: {
                  required: function() { return isSendingToRegistry(':input[name="patientConsent"]'); },
                }
            },
            {
                name: 'partialDate',
                selector: ':input[name="partialDate"]',
                infoText: 'date...',
                datePickerOpts: {},
                changeFn: function() {
                    form.setVal('partialTime', el8.service.tz.newTzTime().asTimeString()); // 00:00:00
                },
                validate: {
                    required: true,
                    validDate: true,
                    todayOrBefore: true,
                    afterYear1900: true
                }
            },
            {
                name: 'partialTime',
                selector: ':input[name="partialTime"]',
                timePickerOpts: {
                    increment: 1
                },
                validate: {
                    required: true,
                },
                defaultVal: function() { return el8.service.tz.now().asTimeString(); }
            },
            {
                name: 'declinedDate',
                selector: ':input[name="declinedDate"]',
                infoText: 'date...',
                datePickerOpts: {},
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="declinedDate"]'); },
                    validDate: true,
                    todayOrBefore: true,
                    afterYear1900: true
                }
            },
            {
                name: 'manualVaccineName',
                selector: ':input[name="manualVaccineName"]',
                infoText: 'add vaccine name...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                doShrink: true,
                maxLength: LONG_FIELD_LENGTH,
                mindreaderOpts: {
                    url: function() {
                        var url = el8.service.urls.get('searchVaccines');
                        return isSendingToRegistry() ? url + "?cvx_required=true&submittable=true" : url;
                    },
                    selectFn: onVaccineSelect,
                    formatResult: function(item) {
                        if (item.cdc_type && item.packaged_name) {
                            return el8.template.mindreader.commonVaccine({item: item});
                        }
                        return el8.template.mindreader.otherVaccine({item: item});
                    },
                    containerWidth: MINDREADER_WIDTH,
                    formatSelected: function(item) {
                        return el8.template.appchart.dialog.addEditImmunizationNew.selectedVaccine(item);
                    }
                },
                newMindreader: true,
                validate: {
                    required: true
                }
            },
            {
                name: 'ndcCode',
                selector: ':input[name="ndcCode"]',
                infoText: 'National Drug Code',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: STD_FIELD_LENGTH,
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="ndcCode"]');  },
                },
                mindreaderOpts: {
                    data: [],
                    containerWidth: MINDREADER_WIDTH,
                    showOnFocus: true
                }
            },
            {
                name: 'qty',
                selector: ':input[name="qty"]',
                infoText: 'qty...',
                maxLength: 10,
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="qty"]'); },
                    number: true
                }
            },
            {
                name: 'qtyUnits',
                selector: ':input[name="qtyUnits"]',
                infoText: 'units...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: STD_FIELD_LENGTH,
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="qtyUnits"]'); },
                    unitsInUCUM: false
                },
                mindreaderOpts: {
                    data: el8.util.consts.IMMUNIZATION_REGISTRY_QUANTITY_UNITS,
                    containerWidth: MINDREADER_WIDTH,
                    showOnFocus: true,
                    newMindreader: true,
                    minQueryLength: 1,
                    listEditor: true,
                    selectFn: function(_, item) {
                        form.setVal('qtyUnits', item);
                        form.setVal('selectQtyUnits', item);
                        form.getInputField('qtyUnits').focus();
                    },
                    selectInputFn: function(event) {
                        form.setVal('qtyUnits', event.target.value);
                        form.setVal('selectQtyUnits', event.target.value);
                        form.getInputField('qtyUnits').focus();
                    }
                }
            },
            {
                name: 'selectQtyUnits',
                selector: ':input[name="selectQtyUnits"]',
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="selectQtyUnits"]'); },
                },
            },
            {
                name: 'doseInSeries',
                selector: ':input[name="doseInSeries"]',
                infoText: '# dose (IA)',
                maxLength: 2,
                validate: {
                    number: true
                }
            },
            {
                name: 'method',
                selector: ':input[name="method"]',
                infoText: 'administration method...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: STD_FIELD_LENGTH,
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="method"]'); },
                },
                mindreaderOpts: {
                    data: el8.util.consts.VACCINE_METHODS,
                    containerWidth: MINDREADER_WIDTH,
                    showOnFocus: true
                }
            },
            {
                name: 'selectMethod',
                selector: ':input[name="selectMethod"]',
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="selectMethod"]'); },
                },
            },
            {
                name: 'site',
                selector: ':input[name="site"]',
                infoText: 'administration site...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: STD_FIELD_LENGTH,
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="site"]'); },
                },
                mindreaderOpts: {
                    data: [],
                    containerWidth: MINDREADER_WIDTH,
                    showOnFocus: true
                }
            },
            {
                name: 'selectSite',
                selector: ':input[name="selectSite"]',
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="selectSite"]'); },
                },
            },
            {
                name: 'manufacturerName',
                selector: ':input[name="manufacturerName"]',
                maxLength: LONG_FIELD_LENGTH,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'name of manufacturer...',
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="manufacturerName"]'); },
                },
                mindreaderOpts: {
                    url: function() { return el8.service.urls.get('searchVaccineManufacturers'); },
                    containerWidth: MINDREADER_WIDTH,
                    formatResult: function(item) {
                        return item.name;
                    },
                    formatSelected: function(item) {
                        return item.name;
                    }
                }
            },
            {
                name: 'selectManufacturerName',
                selector: ':input[name="selectManufacturerName"]',
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="selectManufacturerName"]'); },
                },
            },
            {
                name: 'lotNumber',
                selector: ':input[name="lotNumber"]',
                maxLength: LONG_FIELD_LENGTH,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'lot number...',
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="lotNumber"]'); }
                },
            },
            {
                name: 'expirationDate',
                selector: ':input[name="expirationDate"]',
                infoText: 'date...',
                datePickerOpts: {},
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="expirationDate"]'); },
                },

            },
            {
                name: 'reason',
                selector: ':input[name="reason"]',
                maxLength: LONG_FIELD_LENGTH,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'reason for vaccinating...'
            },
            {
                name: 'vis',
                selector: ':input[name="vis"]',
                infoText: 'VIS(s) provided to patient...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
            },
            {
                name: 'selectVISHandout',
                selector: ':input[name="selectVISHandout"]',
                validate: {
                    required: function() { return isSendingNewToRegistry(':input[name="selectVISHandout"]'); },
                },
            },
            {
                name: 'administeredBy',
                selector: '.administered-by-field',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'physician name...',
                clickItemOpts: el8.app.shared.clickItemOpts.physicians({
                    newContactCb: function(contact) {
                        if (!contact) { return; }
                        form.setClickItemSelected('administeredBy', {
                            id: contact.getId(),
                            name: contact.getFullName()
                        });
                    }
                }),
                validate: {
                    required: function() {
                        return isSendingNewToRegistry('.administered-by-field') ||
                          !isHistoricalRecord();
                        },
                }
            },
            {
                name: 'orderedBy',
                selector: '.ordered-by-field',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'physician name...',
                clickItemOpts: el8.app.shared.clickItemOpts.physicians({
                    newContactCb: function(contact) {
                        if (!contact) { return; }
                        form.setClickItemSelected('orderedBy', {
                            id: contact.getId(),
                            name: contact.getFullName()
                        });
                    }
                }),
                validate: {
                    required: function() { return !isHistoricalRecord(); },
                }
            },
            {
                name: 'notes',
                selector: ':input[name="notes"]',
                infoText: 'Notes...',
                height: el8.util.consts.XL_FIELD_HEIGHT
            },
            {
                name: 'publicityCode',
                selector: ':input[name="publicityCode"]',
                validate: {
                  required: function() { return isSendingNewToRegistry(':input[name="publicityCode"]'); },
                }
            },
            {
                name: 'vfcEligibility',
                selector: ':input[name="vfcEligibility"]',
                validate: {
                  required: function() { return isSendingNewToRegistry(':input[name="vfcEligibility"]'); },
                }
            },
            {
                name: 'fundingSource',
                selector: ':input[name="fundingSource"]',
                validate: {
                  required: function() { return isSendingNewToRegistry(':input[name="fundingSource"]'); },
                }
            },
            {
                name: 'infoSource',
                selector: ':input[name="infoSource"]',
                validate: {
                  required: function() { return isSendingToRegistry(':input[name="infoSource"]'); },
                }
            },
            {
                name: 'declinedReason',
                selector: ':input[name="declinedReason"]',
                validate: {
                    required: true,
                },
            },
            {
                name: 'packagedMedId',
                selector: ':input[name="packagedMedId"]'
            }
        ],
        firstFocusSelector: ':input[name="manualVaccineName"]',
        validationOpts: el8.util.validate.standardOpts
    });

    // The form action buttons are added separately so that
    // immunizations-specific analytics can be triggered
    form.addSaveButton(function(_form) {
        doSave(_form);
    }, true);
    form.addSaveAndAnotherButton(function(_form) {
        doSave(_form, true);
    }, false);
    form.addDiscardButton(function() {
        that.hide();
        el8.util.amplitude.logImmunizationDialogAction('Discard');
    });

    that.setForm(form);


    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        bindTriggers();
        initializeTooltips();
        initializeSubmissionUI();
    };

    var super_show = that.show;
    that.show = function(spec) {
        manualVaccineValidationEnabled = false; // Disable while populating dialog on show
        super_show.call(that);
        spec = spec || {};

        var patientDeclined = spec.patientDeclined;

        successCb = spec.successCb || null;
        _currImmunizationId = spec.ptImmunizationId || null;
        var currPtImmunization = _currImmunizationId ?
            el8.ptdata.ptImmunizations.getById(spec.ptImmunizationId) : null;

        form._formElt.validate().settings.ignore = "*";
        form.setMindreaderSearchData('method', el8.util.consts.VACCINE_METHODS);
        toggleIsPtDeclineEnabled(false);

        // display reference information
        displayReferenceInfo();
        if (currPtImmunization) {
            populateForm(currPtImmunization);
            form.focusField('manualVaccineName');
        } else {
            that.setTitle('Document Vaccination');
            form.setVal('qtyUnits', 'mL');
            form.setVal('partialDate', el8.service.tz.now().asString());
            form.setVal('declinedDate', el8.service.tz.now().asString());
            form.setVal('partialTime', el8.service.tz.now().asTimeString());
            if (el8.data.currUser.isPhysician()) {
                var currUserDict = {
                    id: el8.data.currUser.getStaffId(),
                    name: el8.data.currUser.getFullName()
                };
                form.setClickItemSelected('administeredBy', currUserDict);
                form.setClickItemSelected('orderedBy', currUserDict);
            }

            // searching for a vaccine keyword (e.g., cdc_type from magictable)
            if (spec.vaccineName) {
                form.setVal('manualVaccineName', spec.vaccineName, true);
                form.getInputField('manualVaccineName').focus();
                form.getMindreader('manualVaccineName').requestResults(spec.vaccineName);
            }
            setRegistrySubmissionIfConfigured();
            $('#aei_infoSource').val('');
        }
        that.adjustPosition();
        if (patientDeclined) {
            form.setVal('selectImmunizationRecord', DECLINED_ACTION);
            toggleIsPtDeclineEnabled(true);
            _declineCode = spec.vaccineName;
        } else {  // Differentiate between administered/historical - must be set on save
            if (HISTORICAL_SOURCES.includes($('#aei_infoSource').val())) {
                form.setVal('selectImmunizationRecord', PREV_ADMIN_ACTION);
            } else {
                form.setVal('selectImmunizationRecord', ADMINISTERED_ACTION);
            }
        }
        selectImmunizationRecordUI();
        if (currPtImmunization && (currPtImmunization.asSoyMap().submissionId !== undefined ||
          currPtImmunization.asSoyMap().allowedSharing === SEND_TO_REGISTRY_ACTION)) {
            toggleAlreadySubmittedToRegistryWarning(true);
        }
        manualVaccineValidationEnabled = true; // enable after dialog is populated
    };

    var super_hide = that.hide;
    that.hide = function() {
        $('.new-vaccine-indicator').empty().hide();
        super_hide.call(that);
        successCb = null;
        _currImmunizationId = null;
        _declineCode = null;
    };


    /*
     * Internal Methods
     */
    function setRegistrySubmissionIfConfigured() {  // If active IR interface and this is a new vaccination, set as default
        var registryCount = $('#aei_selectImmunizationRegistry option').length;
        if (!_currImmunizationId && registryCount > 0) {
            form.setVal('allowedSharing', SEND_TO_REGISTRY_ACTION);
        } else if (registryCount === 0) {  // RM-29126 - RM-28239 - No registries? allowedSharing=null
            form.setVal('allowedSharing', '');
        }
    }

    function validate(imm) {
        if (!form.isValid()) {
            return {result: false, msg: 'Please check the fields outlined in red.'};
        }
        if (form.getVal('expirationDate') && !el8.util.datecompare.dateFromStr(form.getVal('expirationDate'))) {
            return {result: false, msg: 'Please specify a valid vaccine expiration date (or leave the field blank).'};
        }
        return {result: true};
    }

    function addVaccinationGuideClickHandler() {
        that.getWarningElt().on('click', '.open-learn-more-trigger',  function () {
            el8.util.amplitude.logImmunizationDialogLearnMoreLink();
            window.open('https://help.elationemr.com/s/article/Vaccination-Form-Guide', '_blank', 'noopener,noreferrer');
        });
    }

    that._createMissingAddressWarning = function() {
        that.getWarningElt().html(el8.template.appchart.dialog.addEditImmunizationNew.missingAddressWarning());
        that.getWarningElt().on('click', '.open-patient-address-trigger',  function (e) {
            e.preventDefault();
            el8.util.amplitude.logImmunizationDialogDemographicUpdate();
            el8.appshared.dialog.editPatient.show({
                onSaveCallback: function() {
                    if (el8.appchart.dialog.addEditImmunizationNew.isOpen()) {
                        showWarningIfNeeded();
                    }
                }
            });
        });
        addVaccinationGuideClickHandler();
        that.getWarningElt().css('height', '0px').hide();
    };

    that._createOneTimeRegistrySubmission = function() {
        that.getWarningElt().html(el8.template.appchart.dialog.addEditImmunizationNew.oneTimeRegistrySubmission());
        addVaccinationGuideClickHandler();
        that.getWarningElt().css('height', '0px').hide();
    };

    that._createAlreadySubmittedToRegistry = function() {
        that.getWarningElt().html(el8.template.appchart.dialog.addEditImmunizationNew.alreadySubmittedToRegistry());
        that.getWarningElt().css('height', '0px').hide();
    };

    function toggleEnableSaveImmunization(enable) {
        if (enable === false) {
            form.disableButton('save');
            form.disableButton('save-and-another');
        } else {
            form.enableButton('save');
            form.enableButton('save-and-another');
        }
    }

    function showWarningIfNeeded() {
        if (!el8.ptdata.currPatient.getFullAddress()) {
            that._createMissingAddressWarning();
            that.getWarningElt().css('height', 'auto').show();
            that.adjustHeight();
            toggleEnableSaveImmunization(false);
        } else if (form.getVal('selectImmunizationRegistry') !== "") {
            that._createOneTimeRegistrySubmission();
            toggleOneTimeSubmissionWarning(true);
            toggleEnableSaveImmunization(true);
        } else {
            hideCurrentWarning();
        }
    }
    function hideCurrentWarning() {
        that.getWarningElt().css('height', '0px').hide();
        that.adjustHeight();
        toggleEnableSaveImmunization(true);
    }

    function toggleOneTimeSubmissionWarning(showWarning) {
        if (showWarning) {
            that._createOneTimeRegistrySubmission();
            that.getWarningElt().css('height', 'auto').show();
        } else {
            that.getWarningElt().css('height', '0px').hide();
        }
        that.adjustHeight();
    }

    function toggleAlreadySubmittedToRegistryWarning(showWarning) {
        if (showWarning) {
            that._createAlreadySubmittedToRegistry();
            that.getWarningElt().css('height', 'auto').show();
        } else {
            that.getWarningElt().css('height', '0px').hide();
        }
        that.adjustHeight();
    }

    function selectImmunizationRecordUI() {
        // show different UI controls when the user is administering or declining
        var recordSelected = form.getVal('selectImmunizationRecord');
        if (recordSelected === ADMINISTERED_ACTION) {
            $('.registry-info').show();
            $('.patient-declined-action').hide();
            $('.administered-action').show();
            $('.el8RequiredNewSubmissionAsterisk, .el8RequiredNewAdministeredAsterisk').show();
            $('.el8HistoricalOnlyField').hide();
        } else if (recordSelected === PREV_ADMIN_ACTION) {
            $('.registry-info').show();
            $('.patient-declined-action').hide();
            $('.administered-action').show();
            $('.el8RequiredNewSubmissionAsterisk, .el8RequiredNewAdministeredAsterisk').hide();
            $('.el8HistoricalOnlyField').show();
        } else if (recordSelected === DECLINED_ACTION) {
            $('.patient-declined-action').show();
            $('.administered-action').hide();
            $('.el8RequiredNewSubmissionAsterisk, .el8RequiredNewAdministeredAsterisk').hide();
            $('.registry-info').hide();
            $('.el8HistoricalOnlyField').hide();
        }
        selectSendToRegistryUI();
        that.adjustPosition();
    }

    function toggleRestrictedQtyUnits(doShow) {
        doShow = typeof doShow !== 'undefined' ? doShow : true;
        if (doShow === true) {
            $('#aei_qtyUnits').hide();
            $('#aei_selectQtyUnits').show();
        } else {
            $('#aei_selectQtyUnits').hide();
            $('#aei_qtyUnits').show();
        }
    }

    function toggleRestrictedVIS(doShow) {
        doShow = typeof doShow !== 'undefined' ? doShow : true;
        if (doShow === true) {
            $('#aei_vis').hide();
            $('#aei_selectVISHandout').show();
        } else {
            $('#aei_selectVISHandout').hide();
            $('#aei_vis').show();
        }
    }

    function toggleRestrictedManufacturer(doShow) {
        doShow = typeof doShow !== 'undefined' ? doShow : true;
        if (doShow === true) {
            $('#aei_manufacturerName').hide();
            $('#aei_selectManufacturerName').show();
        } else {
            $('#aei_selectManufacturerName').hide();
            $('#aei_manufacturerName').show();
        }
    }

    function toggleRestrictedSite(doShow) {
        doShow = typeof doShow !== 'undefined' ? doShow : true;
        if (doShow === true) {
            $('#aei_site').hide();
            $('#aei_selectSite').show();
        } else {
            $('#aei_selectSite').hide();
            $('#aei_site').show();
        }
    }

    function toggleRestrictedMethod(doShow) {
        doShow = typeof doShow !== 'undefined' ? doShow : true;
        if (doShow === true) {
            $('#aei_method').hide();
            $('#aei_selectMethod').show();
            bindSelectMethodTrigger();
        } else {
            $('#aei_selectMethod').hide();
            $('#aei_method').show();
            bindMethodTrigger();
        }
    }

    function toggleRelevantRegistryFieldsByRecordAction(recordSelected) {
        if (recordSelected === DECLINED_ACTION) {
            $('.registry-info').hide();
            $('.registry-hidden-when-declined').hide();
        } else {
            $('.registry-info').show();
            $('.registry-hidden-when-declined').show();
        }
    }

    /**
     * Note - currently no specific user feedback is given about why their selection
     * was cleared. Do nothing if during initial dialog population so that we can display
     * previously submitted vaccines that didn't have CVX codes.
     */
    function clearSelectedVaccineIfNoValidCvx() {
        if (manualVaccineValidationEnabled !== true) { return; }
        var selectedVaccine = form.getMindreaderItem('manualVaccineName');
        if (selectedVaccine === "" ||
             (selectedVaccine &&
               (selectedVaccine.id === null || selectedVaccine.cvx === null ||
               CVX_CODES_TO_EXCLUDE.includes(selectedVaccine.cvx.toString())))) {
            form.setVal('manualVaccineName', '', true);  // Clear the selection
            $(':input[name="manualVaccineName"]').change();
        }
    }

    function selectSendToRegistryUI() {
        // show different UI controls when the user is sending to registry or not
        var registrySelected = form.getVal('allowedSharing');
        var recordSelected = form.getVal('selectImmunizationRecord');
        var infoSource = $('#aei_infoSource');

        if (registrySelected === SEND_TO_REGISTRY_ACTION) {
            $('.registry-sending-info').show();
            clearSelectedVaccineIfNoValidCvx();
            toggleRelevantRegistryFieldsByRecordAction(recordSelected);
            $('.el8RequiredSubmissionAsterisk').show();
            showWarningIfNeeded();
            if (recordSelected === ADMINISTERED_ACTION) {
                $('.el8RequiredNewSubmissionAsterisk, .el8RequiredNewAdministeredAsterisk').show();
                toggleRestrictedVIS(true);
                toggleRestrictedManufacturer(true);
                toggleRestrictedQtyUnits(true);
                toggleRestrictedSite(true);
                toggleRestrictedMethod(true);
            } else if (recordSelected === PREV_ADMIN_ACTION) {
                $('.el8RequiredNewSubmissionAsterisk, .el8RequiredNewAdministeredAsterisk').hide();
                toggleRestrictedVIS(false);
                toggleRestrictedManufacturer(false);
                toggleRestrictedQtyUnits(false);
                toggleRestrictedSite(false);
                toggleRestrictedMethod(false);
                if (!HISTORICAL_SOURCES.includes(infoSource.val())) {
                    infoSource.val("");
                }
            }
        } else {  // Handle empty as well as explicitly 'no'
            $('.registry-sending-info').hide();
            hideCurrentWarning();
            toggleRestrictedVIS(false);
            toggleRestrictedManufacturer(false);
            toggleRestrictedQtyUnits(false);
            toggleRestrictedSite(false);
            toggleRestrictedMethod(false);
            $('.el8RequiredNewSubmissionAsterisk').hide();
            $('.el8RequiredSubmissionAsterisk').hide();
            $(':input[name="patientConsent"]').val("");  // RM-28389 Reset consent if change to not sharing
        }
        that.adjustPosition();
        $("#add-edit-immunization-form").valid();
    }

    function isHistoricalRecord() {
        return (form.getVal('selectImmunizationRecord') === PREV_ADMIN_ACTION);
    }

    function isSendingToRegistry(selectorText) {
        var recordSelected = form.getVal('allowedSharing');
        if (selectorText !== undefined) {
            if (isInputShown(selectorText)) {
                return recordSelected === SEND_TO_REGISTRY_ACTION;
            } else {
                return false;
            }
        } else {
            return recordSelected === SEND_TO_REGISTRY_ACTION;
        }
    }

    function isSendingNewToRegistry(selectorText) {
        var isNewRecord = form.getVal('selectImmunizationRecord') === ADMINISTERED_ACTION;
        return isNewRecord && isSendingToRegistry(selectorText);
    }

    function isInputShown(selectorText) {
        return $(selectorText).is(':visible');
    }

    function didValidate(ptImmOrDecline) {
        var validated = validate(ptImmOrDecline);
        if (!validated.result) {
            el8.uiwidget.alert(validated.msg);
            return false;
        }
        return true;
    }

    function doSave(_form, addAnother) {
        form._formElt.validate().settings.ignore = ":hidden";

        if (form.getVal('selectImmunizationRecord') === DECLINED_ACTION) {
            savePtDecline();
            return;
        }

        var formMap = form.getMapped();
        if (form.getVal('selectImmunizationRecord') === PREV_ADMIN_ACTION &&
          (!HISTORICAL_SOURCES.includes(form.getVal('infoSource')))) {
            formMap.info_source = HISTORICAL_SOURCES[0];
        } else if (form.getVal('selectImmunizationRecord') === ADMINISTERED_ACTION) {
            formMap.info_source = NEW_INFO_SOURCE;
        } else {
            formMap.info_source = form.getVal('infoSource');
        }
        if (form.getMindreaderItem('manualVaccineName')) {
            formMap.vaccine_id = form.getMindreaderItem('manualVaccineName').id;
        }
        if (form.getClickItemId('administeredBy')) {
            formMap.administering_physician_id = form.getClickItemId('administeredBy');
            delete formMap.administeredBy;
        } else if (form.getClickItem('administeredBy').getItemVal()) {  // Manual entry
            formMap.administering_physician_id = null;
        }
        if (form.getClickItemId('orderedBy')) {
            formMap.ordering_physician_id = form.getClickItemId('orderedBy');
            delete formMap.orderedBy;
        } else if (form.getClickItem('orderedBy').getItemVal()) {  // Manual entry
            formMap.ordering_physician_id = null;
        }
        // We now have a few different controls that display depending on whether we are
        // submitting to an immunization registry. Set these values conditionally.
        if (formMap.allowedSharing === SEND_TO_REGISTRY_ACTION) {
            if (formMap.vaccine_id === undefined) {  // Won't send to registry - remove
                clearSelectedVaccineIfNoValidCvx();
                return;
            }
            if (formMap.selectVISHandout) {
                formMap.vis = formMap.selectVISHandout;
            }
            if (formMap.selectManufacturerName) {
                formMap.manufacturerName = formMap.selectManufacturerName;
            }
            if (form.getVal('selectImmunizationRecord') === ADMINISTERED_ACTION) {
                formMap.qtyUnits = formMap.selectQtyUnits;
            }
            if (formMap.selectSite) {
                formMap.site = formMap.selectSite;
            }
            if (formMap.selectMethod) {
                formMap.method = formMap.selectMethod;
            }
        }

        var currPtImmunization = null;
        if (_currImmunizationId) {
            currPtImmunization = el8.ptdata.ptImmunizations.getById(_currImmunizationId);
            currPtImmunization.populate(formMap);
            // RM-28239 - If no registries configured to share, set allowedSharing to null
            if ($('#aei_selectImmunizationRegistry option').length === 0) {
                currPtImmunization.allowedSharing = '';
            }
        } else {
            currPtImmunization = el8.ptdata.ptImmunizations.create(formMap, true);
        }
        // If the user changes allowedSharing to no/unset, change patientConsent to unset
        if (currPtImmunization.allowedSharing !== "yes") {
            currPtImmunization.patientConsent = '';
        }
        currPtImmunization.setAdministeredDate(getSelectedDateTime());

        if (!didValidate(currPtImmunization)) { return; }

        el8.util.amplitude.logImmunizationDialogAction(addAnother ? 'Save & Add Another' : 'Save');

        el8.ptdata.ptImmunizations.saveItem(currPtImmunization, false, {
            successCb: function() {
                // only add a new note if this is a new immunization, administered today, not an edit / historical entry
                if (_currImmunizationId === null &&
                        el8.util.datecompare.isSameDay(currPtImmunization.getAdministeredDate(), el8.service.tz.today()) &&
                        el8.appchart.mgr.notes.someNoteIsShowing()) {
                    el8.appchart.mgr.notes.addReference({item: currPtImmunization, sectionName: 'tx'});
                }
                if (successCb) { successCb(currPtImmunization); }
                that.hide();
                el8.util.amplitude.logImmunizationDialogSave({
                    adminProvider: Boolean(formMap.administering_physician_id),
                    consent: Boolean(formMap.patientConsent === SEND_TO_REGISTRY_ACTION),
                    notes: Boolean(formMap.notes),
                    orderProvider: Boolean(formMap.ordering_physician_id),
                    patientPopulation: formMap.priorityPopulation,
                    reason: Boolean(formMap.reason),
                    submitRegistry: Boolean(formMap.allowedSharing === SEND_TO_REGISTRY_ACTION)
                });
                if (addAnother === true) { that.show(); }
            }
        });
    }

    function savePtDecline() {
        var mindreaderItem = form.getMindreaderItem('manualVaccineName');
        // get the cdc_type from the mindreader, if there has been a selection there, and from the
        //  pre-population we did if we opened this dialog from the magic table, if not
        var cdcType = (mindreaderItem) ? mindreaderItem.cdc_type : _declineCode;
        if (!cdcType) {
            // button should be disabled here, but there might be some cases where it slips
            el8.uiwidget.alert('Please select a vaccine with a CDC Type, from the popular list to record a decline.');
            toggleIsPtDeclineEnabled(false);
            return;
        }
        var declineDate = getDeclinedDate();  // RM-27209 Take from decline-specific field
        if (!declineDate) {
            el8.uiwidget.alert('Please enter a date for the immunization decline in the "Given on" field.');
            return;
        }

        var newDeclineCb = function(item) {
            if (el8.appchart.mgr.notes.someNoteIsShowing()) {
                el8.appchart.mgr.notes.addReference({item: item, sectionName: 'tx'});
            }
            that.hide();
        };
        var decline = el8.ptdata.ptImmunizationDeclines.create({
            cdcType: cdcType,
            declinedDate: declineDate,
            declinedReason: form.getVal('declinedReason'),
            vaccineId: mindreaderItem.id,
            allowedSharing: form.getVal('allowedSharing'),
            selectImmunizationRegistry: form.getVal('selectImmunizationRegistry')
        }, true);

        if (!didValidate(decline)) { return; }

        el8.ptdata.ptImmunizationDeclines.saveItem(
            decline, false, { successCb: newDeclineCb }
        );
    }

    function initializeTooltips() {
        el8.service.tooltip.create({
            anchor: $('.pt-declined-anchor', that.getContentElt()),
            text: el8.template.appchart.dialog.addEditImmunizationNew.vaccDeclinedTooltip()
        });
    }

    /**
     * This function populates a select control specified by selectId with the array data
     * and optionally filters out the data with member type if typeFilter is set
     * @param {array} data
     * @param {string} selectId selector id
     * @param {int} typeFilter (nullable)
     */
    function populateDedupedSelectValues(data, selectId, typeFilter) {
        var select = $("#"+selectId);
        if (select.length && select.is('select') && (Array.isArray(data) || !data.length)) {
            var prePopulatedValues = Array.apply(null, document.getElementById(selectId).options).map(function(e) { return e.value; });
            select.prepend('<option value="">--</option>');
            var dedupedValues = data.filter(function(i) { return !prePopulatedValues.includes(i.name); });
            dedupedValues.forEach(function(value) {
                if (!typeFilter) {  // Just add them all
                    select.append(new Option(value.name, value.name));
                } else if (typeFilter && value.type === typeFilter) {  // Handouts
                    select.append(new Option(value.name, value.name));
                }
            });
        }
    }

    /**
     * Determine whether to show controls for allowing user to select whether to submit
     * to an immunization registry
     */
    function initializeSubmissionUI() {
        toggleEnableSaveImmunization(false);
        $.el8_ajax({
            url: el8.service.urls.get('getRegistryIntegrations', [registrySubmissionTypeIds]),
            type: 'GET',
            success: function(data) {
                if (!Array.isArray(data) || !data.length) {
                    $('.featureIRSubmissions').hide();
                } else {
                    $('#aei_selectImmunizationRegistry').find('option').remove();
                    var practiceIRs = data.sort(function(a,b) {
                        return (a.region.toLowerCase() < b.region.toLowerCase()) ? -1 : 1;
                    });
                    practiceIRs.forEach(function(ir) {
                        $('#aei_selectImmunizationRegistry').append(
                          new Option("(" + ir.code + ") " + ir.description + " (" + ir.site_id + ")", ir.integration_id)
                        );
                    });
                    $('.featureIRSubmissions').show();
                    manualVaccineValidationEnabled = false;
                    if(_currImmunizationId) {
                        that.show({ ptImmunizationId: _currImmunizationId });
                    }
                    setRegistrySubmissionIfConfigured();
                    manualVaccineValidationEnabled = true;
                }
                toggleEnableSaveImmunization(true);
            },
            error: function() {
                // Hide interface and log this event
                $('.featureIRSubmissions').hide();
                var erText = "Error retrieving list from getRegistryIntegrations";
                erText += "  in addEditImmunizationNew.js for practiceId=" + el8.ptdata.practiceId;
                if (UIM) { UIM.logError(erText); }
                toggleEnableSaveImmunization(true);
            },
        });

        $.el8_ajax({
            url: el8.service.urls.get('getEducationalHandouts'),
            type: 'GET',
            success: function(data) {
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });

                populateDedupedSelectValues(data, "aei_selectVISHandout", 2);
            },
            error: function() {  // Hide interface and log this event
                var erText = "Error retrieving list from getVISHandouts";
                erText += " in addEditImmunizationNew.js for practiceId=" + el8.ptdata.practiceId;
                console.log(erText);  // For local debugging
                UIM && UIM.logError(erText);
            }
        });

        $.el8_ajax({
            url: el8.service.urls.get('mvxCodes'),
            type: 'GET',
            success: function(data) {
                if (data) {
                    data.sort(function(a,b) {  // CircleCI doesn't like '=>' notation
                        return a.name.localeCompare(b.name, undefined, {sensitivity: 'base'});
                    });
                    populateDedupedSelectValues(data, "aei_selectManufacturerName", null);
                }
            },
            error: function() {  // Hide interface and log this event
                var erText = "Error retrieving list from mvxCodes";
                erText += " in addEditImmunizationNew.js for practiceId=" + el8.ptdata.practiceId;
                console.log(erText);  // For local debugging
                UIM && UIM.logError(erText);
            }
        });

        $('#aei_selectQtyUnits').empty().prepend('<option value="">--</option>');
        el8.util.consts.IMMUNIZATION_REGISTRY_QUANTITY_UNITS.forEach(function(unit) {
            $('#aei_selectQtyUnits').append(new Option(unit, unit, unit === "mL"));
        });
    }

    function toggleIsPtDeclineEnabled(isEnabled) {
        if (isEnabled) {
            $('.pt-declined-check', that.getContentElt()).removeAttr('disabled');
            $("select[name='selectImmunizationRecord'] option[value='patientDeclined']").attr('disabled', false);
        } else {
            $('.pt-declined-check', that.getContentElt()).attr('disabled', 'disabled');
            var sir = $("select[name='selectImmunizationRecord']");
            $("option[value='patientDeclined']", sir).attr('disabled', 'disabled');
            if (sir.val() === "patientDeclined") {
                sir.val(0);
                selectImmunizationRecordUI();
            }
        }
    }

    function populateSiteAutocompleteOptions(method) {
        method = String(method).toLowerCase().trim();
        if (!isSiteFieldRelevant(method)) {
            form.hideField('site'); /* the field is redundant for oral and intranasal vaccines */
            form.getField('site').setVal('');
        } else {
            form.showField('site'); //in case the field was previously hidden

            /* set Site field autocomplete options */
            if (method === 'subcutaneous' || method === 'sc' || method === 'subcutaneous (sc)') {
                form.setMindreaderSearchData('site', el8.util.consts.VACCINATION_SITES_SUBCUTANEOUS);
                $('#aei_selectSite').empty().prepend('<option value="">--</option>');
                el8.util.consts.VACCINATION_SITES_SUBCUTANEOUS.forEach(function(unit) {
                    $('#aei_selectSite').append(new Option(unit, unit));
                });
            } else if (method === 'intramuscular' || method === 'im' || method === 'intramuscular (im)') {
                form.setMindreaderSearchData('site', el8.util.consts.VACCINATION_SITES_INTRAMUSCULAR);
                $('#aei_selectSite').empty().prepend('<option value="">--</option>');
                el8.util.consts.VACCINATION_SITES_INTRAMUSCULAR.forEach(function(unit) {
                    $('#aei_selectSite').append(new Option(unit, unit));
                });
            } else {
                form.setMindreaderSearchData('site', []);
                $('#aei_selectSite').empty();
            }
        }
    }

    function bindMethodCallback() {
        var method = form.getField('method').getVal();
        populateSiteAutocompleteOptions(method);
    }

    function bindSelectMethodCallback() {
        var selectMethod = form.getVal('selectMethod');
        populateSiteAutocompleteOptions(selectMethod);
    }

    function bindMethodTrigger() {
        that.getContentElt().off('change', ':input[name="selectMethod"]', bindSelectMethodCallback);
        that.getContentElt().on('change', ':input[name="method"]', bindMethodCallback);
    }

    function bindSelectMethodTrigger() {
        that.getContentElt().off('change', ':input[name="method"]', bindMethodCallback);
        that.getContentElt().on('change', ':input[name="selectMethod"]', bindSelectMethodCallback);
    }

    function bindTriggers() {
        /* Show an "unknown vaccine" error for any Vaccine field that is not:
         * (1) empty, (2) chosen from the mindreader,
         * (3) in the process of being replaced by the mindreader
         */
        that.getContentElt().on('change', ':input[name="manualVaccineName"]',  function() {
            var mindreaderItem = form.getMindreaderItem('manualVaccineName');
            if (mindreaderItem) {
                $('.new-vaccine-indicator').empty().hide();
                if (mindreaderItem.cdc_type) { toggleIsPtDeclineEnabled(true); }

            } else if (form.getField('manualVaccineName').getVal() === '') {
                form.setMindreaderSearchData('method', el8.util.consts.VACCINE_METHODS);
                $('.new-vaccine-indicator').empty().hide();
                toggleIsPtDeclineEnabled(false);

            } else {
                form.setMindreaderSearchData('method', el8.util.consts.VACCINE_METHODS); //reset Method for unknown vaccine
                $('.new-vaccine-indicator').show().html(
                    el8.template.appchart.dialog.addEditImmunizationNew.unknownVaccine()
                );
                toggleIsPtDeclineEnabled(false);
            }
        });

        /* The Site field shows/hides and has auto-complete options based on the Method field */
        bindMethodTrigger();

        that.getContentElt().on('click', '.educational-handouts-trigger',  function(event) {
            event.preventDefault();
            el8.appshared.dialog.viewEducationalHandouts.show();
        });
    }

    function getSelectedDateTime() {
        return el8.service.tz.processDateAndTimeInputs(form.getVal('partialDate'), form.getVal('partialTime'));
    }

    function getDeclinedDate() {
        return el8.service.tz.newTzDate(form.getVal('declinedDate'));
    }

    /* Oral and Intranasal methods are associated with exactly one site */
    function isSiteFieldRelevant(method) {
        method = method.toLowerCase().trim();
        return (method !== 'oral' && method !== 'po' && method !== 'oral (po)' &&
                method !== 'intranasal' && method !== 'nas' &&
                method !== 'intranasal (ns)' && method !== 'nasal');
    }

    /* Pull the relevant string out of the array of patient_type/dose string pairs
     * that comes down from the server */
    function getDisplayDose(doses, age) {
        if (!doses) { return; }
        var patientType;
        var displayDose = '';

        if (age <= el8.util.consts.PATIENT_TYPE_MAX_AGE_MAP['infant']) {
            patientType = 'infant';
        } else if (age <= el8.util.consts.PATIENT_TYPE_MAX_AGE_MAP['children']) {
            patientType = 'children';
        } else {
            patientType = 'adult';
        }
        for (var i = 0; i < doses.length; i++) {
            if (doses[i].patient_type && doses[i].patient_type === patientType) {
                displayDose = doses[i].dose;
            }
        }

        return (displayDose && displayDose.toLowerCase() !== 'none') ? displayDose : null;
    }


    /* mindreader selectFn: fill out any fields we can based on the vaccine selected */
    function onVaccineSelect(event, item) {
        var autocompleteFromObject = function(fieldName, fieldData) {
            form.setVal(fieldName, fieldData || '');  // Clear previous values
            // Handle select lists from new submission select field
            if (typeof form.getField(fieldName).getInputField === "function") {
                form.getField(fieldName).getInputField().change();
            } else if (typeof form.getField(fieldName).change === "function") {
                form.getField(fieldName).change();
            }
        };
        var selectedVaccine = form.getMindreaderItem('manualVaccineName');
        if (!selectedVaccine || !selectedVaccine.id) { return; }
        $.el8_ajax({
            url: el8.service.urls.get('vaccinePreferences', [selectedVaccine.id, selectedVaccine.packaged_med_id]),
            type: 'GET',
            success: function(data) {
                if (!data) { return; }
                autocompleteFromObject('lotNumber', data.lot_number);
                autocompleteFromObject('expirationDate', data.expiration_date);
                autocompleteFromObject('qty', data.qty);
                autocompleteFromObject('qtyUnits', data.qty_units);
                autocompleteFromObject('selectQtyUnits', data.qty_units);
                autocompleteFromObject('manufacturerName', data.manufacturer_name);
                autocompleteFromObject('selectManufacturerName', data.manufacturer_name);
            }
        });
        autocompleteFromObject('packagedMedId', selectedVaccine.packaged_med_id);
        autocompleteFromObject('method', selectedVaccine.route);
        autocompleteFromObject('selectMethod', selectedVaccine.route);
        autocompleteFromObject('manufacturerName', selectedVaccine.manuf_name);
        autocompleteFromObject('selectManufacturerName', selectedVaccine.manuf_name);
        autocompleteFromObject('ndcCode', selectedVaccine.ndc);
        // If we get a list of all possible ndc_values from Vaccine then update this field
        // to be a mindreader backed on the data in selectedVaccine.ndc_values
        if (!(selectedVaccine.ndc_values === undefined || selectedVaccine.ndc_values.length === 0)) {
            form.setMindreaderSearchData('ndcCode', selectedVaccine.ndc_values);
        }
        item.display_dose = getDisplayDose(item.doses, el8.ptdata.currPatient.getAge());
        if (selectedVaccine.display_dose) {
            var splitQty = selectedVaccine.display_dose.split(" ");
            if (splitQty && splitQty.length === 2) {
                autocompleteFromObject('qty', splitQty[0]);
                autocompleteFromObject('qtyUnits', splitQty[1]);
                autocompleteFromObject('selectQtyUnits', splitQty[1]);
            }
        }
    }

    /**
     * This is used for fields that are populated by ajax calls, we want to populate the
     * selected value on form initialization so we add the value if it doesn't already
     * exist, knowing those ajax calls won't add an already existing value.
     * @param {str} selectId
     * @param {str} control_id
     * @param {str} value
     */
    function addOptionIfMissingAndSelect(selectId, control_id, value) {
        if ($("#"+selectId+" option[value='"+value+"']").length === 0) {
            $("#"+selectId).append(new Option(value, value));
        }
        form.setVal(control_id, value);
    }

    function populateForm(ptImmunization) {
        that.setTitle('Edit Vaccination');
        if (isSiteFieldRelevant(ptImmunization.getMethod())) {
            form.showField('site');
        }

        var formMap = ptImmunization.asSoyMap();
        form.populate(formMap);

        form.setVal('manualVaccineName', formMap.description);
        form.setVal('partialDate', ptImmunization.getAdministeredDate().asString());
        form.setVal('partialTime', ptImmunization.getAdministeredDate().asTimeString());

        var allowedSharing = ptImmunization.getAllowedSharing();
        /* 2021.09.29 There is a somewhat confusing (and potentially problematic)
         * overloading of what allowed_sharing means here, because
         *  In the Ironbridge context it means whether the patient consents to share PII,
         *  In the CAIR context it is the only indication of whether it should be/was
         *   submitted to CAIR.
         * Having wasSent set true if either one of these things are set should display
         * things properly though, as w/IB allowedSharing can only be yes/no on a
         * submitted immunization (null otherwise)
         *
         * 2022.05.12 RM-28389 - We're decoupling the allowed_sharing indicator from
         * whether the patient consented to share PII, creating a new value
         * 'patient_consent' to track that information
         */
        var wasSent = formMap.submissionId !== undefined || allowedSharing === SEND_TO_REGISTRY_ACTION
          ? SEND_TO_REGISTRY_ACTION : DONT_SEND_TO_REGISTRY_ACTION;
        form.setVal('allowedSharing', wasSent);
        if (wasSent === SEND_TO_REGISTRY_ACTION) { // Update submission-specific fields
            var sentTo = formMap.submission.practice_registry_id;
            if (sentTo) {  // Submitted after the new IR work rolled out
                form.setVal('selectImmunizationRegistry', sentTo);
                $("#aei_selectImmunizationRegistry option[value='-1']").remove();
            } else {  // Sent before we tracked submissions properly
                var prevSub = "Previously submitted to a registry";
                // Check to see if this is in the list before adding it
                if (!$('#aei_selectImmunizationRegistry option').filter(function() {
                    return $(this).text() === prevSub;
                })) {
                    $('#aei_selectImmunizationRegistry').append(new Option(prevSub, "-1"));
                }
                form.setVal('selectImmunizationRegistry', "-1");
            }
            form.setVal('selectMethod', formMap.method);
            $(':input[name="selectMethod"]').change();  // Triggers population of site list
            form.setVal('selectSite', formMap.site);
            form.setVal('selectQtyUnits', ptImmunization.getQtyUnits());
            addOptionIfMissingAndSelect("aei_selectVISHandout", "selectVISHandout", formMap.vis);
            addOptionIfMissingAndSelect("aei_selectManufacturerName", "selectManufacturerName", formMap.manufacturerName);
        }
        if (ptImmunization.getAdministeringPhysicianId()) {
            form.setClickItemSelected('administeredBy', {
                id: ptImmunization.getAdministeringPhysicianId(),
                name: ptImmunization.getAdministeringPhysicianName()
            });
        }
        if (ptImmunization.getOrderingPhysicianId()) {
            form.setClickItemSelected('orderedBy', {
                id: ptImmunization.getOrderingPhysicianId(),
                name: ptImmunization.getOrderingPhysicianName()
            });
        }
        if (ptImmunization.getPriorityPopulation()) {
            form.setClickItemSelected('priorityPopulation', {
                id: ptImmunization.getPriorityPopulation()
            });
        }
        form.setVal('allowedSharing', allowedSharing);
    }

    function displayReferenceInfo() {
        /**
         * Do all the styling of the way allergies + drug intols are displayed
         */

        var patientInfoDiv = $('#add-edit-immunization-form-cds');
        var makeContainerRed = false;

        /**
         * Update display
         */
        $('.allergy-values', patientInfoDiv).text(el8.ptdata.ptAllergies.getSummary());
        $('.intolerance-values', patientInfoDiv).html(el8.ptdata.ptIntolerances.getSummary());

        // If there are no known allergies, then make grey
        if (el8.ptdata.ptAllergies.isDocumentedAsNone()) {
            $('.pt-allergies', patientInfoDiv).addClass('el8555');
        } else { // else, make red if there are known allergies OR if they are unknown!
            makeContainerRed = true;
            $('.pt-allergies', patientInfoDiv).removeClass('el8555');
        }

        if (makeContainerRed) {
            patientInfoDiv.addClass('alert');
        } else {
            patientInfoDiv.removeClass('alert');
        }

        // If patient intols is more than 5 a toggles will appear to show the remaining intols.
        if (el8.ptdata.ptIntolerances.all().length > 5) {

            var comma = patientInfoDiv.find('.comma-separator');
            var moreIntols = patientInfoDiv.find('.more-intols');
            var moreIntolsTrigger = patientInfoDiv.find('.more-intols-trigger');

            comma.hide();
            moreIntols.hide();

            $(patientInfoDiv)
                .on('click', '.more-intols-trigger',  function() {
                    comma.show();
                    moreIntols.show();
                    moreIntolsTrigger.hide();
                    return false;
                })
                .on('click', '.less-intols-trigger',  function() {
                    comma.hide();
                    moreIntols.hide();
                    moreIntolsTrigger.show();
                    return false;
                });
        }
    }

    return that;

})();
